import { render } from "./DataViewer.vue?vue&type=template&id=6789cb3a"
import script from "./DataViewer.vue?vue&type=script&lang=js"
export * from "./DataViewer.vue?vue&type=script&lang=js"
script.render = render

export default script